import "./index.scss";
import { $, $all, forEach, on, addClass, removeClass } from "@olmokit/dom";

import { globalData } from "@olmokit/core/data";
import { post } from "@olmokit/core/fragments/ajax";
import LazyLoad from "@olmokit/core/lazy";
import { render } from "@olmokit/utils/render";

import ScrollToPlugin from "gsap/ScrollToPlugin";
import gsap from "gsap";
gsap.registerPlugin(ScrollToPlugin);

const $product = $("#card-product");

const renderCardProduct = render($product.innerHTML);

/**
 * Component: CategoryPagination
 */
export function Pagination() {
  console.log("Pagination mounted.");

  const $links = $all('a.page-link');
  const $items = $all('.page-item');
  forEach($links, (link) => {
    on(link, 'click', () => {
      
      const $element = $('.border-top');
      
      gsap.to(window, { duration: 0.2, scrollTo: $element });      
      const href = link.getAttribute('href');

      forEach($items, (item) => {
        removeClass(item, 'active');
      });

      addClass(link.parentNode, 'active');

      filter(href);
      // console.log(href);
    });
  });

}

function filter(id) {

  const loader = $('.loader');
  // const numProd = $('#numProd');

  loader.style.display = 'flex';  

  post('models', {
    data: {
      page: id.replace('#', ''),
      macroid: globalData.macroidcat,
      catid: globalData.idcat
    },
  }).then(({ data }) => {

    const $products = $("#card-products");
    const $numProd = $("#productFound");
    const $currentSelectionStart = $("#currentSelectionStart");
    const $currentSelectionEnd = $("#currentSelectionEnd");

    $products.innerHTML = renderCardProduct({
      results: data.response
    });
    // new LazyLoad();
    // TODO: da sistemare che il caolo non va bene 
    $numProd.innerHTML = data.total;
    $currentSelectionStart.innerHTML = (data.pagecurrent * data.total) - data.total;
    $currentSelectionEnd.innerHTML = data.pagecurrent * data.total;

    loader.style.display = 'none';

  });      
}
